import { bl_mrp_process_template_import_file_hdr_RowClass } from "../../dbschema/bl_mrp_process_template_import_file_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class ProcessTemplateImportFileContainerModel extends BaseContainerModel {
    bl_mrp_process_template_import_file_hdr: bl_mrp_process_template_import_file_hdr_RowClass = new bl_mrp_process_template_import_file_hdr_RowClass();
}